// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const annihilape: PokeData = {
  "id": 979,
  "name": "annihilape",
  "height": 12,
  "weight": 560,
  "base_experience": 268,
  "types": [
    PokeType.FIGHTING,
    PokeType.GHOST
  ],
  "api_moves": [
    "scratch",
    "thrash",
    "leer",
    "low-kick",
    "counter",
    "seismic-toss",
    "screech",
    "focus-energy",
    "fury-swipes",
    "outrage",
    "swagger",
    "cross-chop",
    "shadow-punch",
    "close-combat",
    "assurance",
    "fling",
    "final-gambit",
    "stomping-tantrum",
    "rage-fist"
  ],
  "moves": [
    "scratch",
    "leer",
    "seismic-toss",
    "outrage",
    "close-combat",
    "shadow-sneak",
    "spectral-snatch",
    "shadow-ball",
    "karate-chop",
    "vacuum-wave",
    "lick",
    "drain-punch",
    "spectral-chain"
  ],
  "evolution_chain": {
    "id": 24,
    "item": null,
    "species": [
      {
        "name": "mankey",
        "order": 61,
        "types": [
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "primeape",
        "order": 62,
        "types": [
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": 56,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 28,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "annihilape",
        "order": 1010,
        "types": [
          PokeType.FIGHTING,
          PokeType.GHOST
        ],
        "evolves_from_species_id": 57,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.OTHER
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 129,
    "speed": 119,
    "ability_power": 152
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
